export default "__VITE_ASSET__BtFpvvdW__"